<template>
    <div class="card" v-if="loadForm" v-loading="loading_submit">
        <Keypress key-event="keyup"
                  @success="checkKey"/>
        <Keypress key-event="keyup" :multiple-keys="multiple" @success="checkKeyWithAlt"/>
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <header class="clearfix" v-if="showHeaderForm">
                <header-form :company="company"
                             :establishment="establishment">
                </header-form>
            </header>
            <form autocomplete="off" @submit.prevent="preSubmit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group" :class="{'has-danger': errors.customer_id}">
                                        <label class="control-label font-weight-bold text-info">
                                            Cliente
                                            <a href="#" @click.prevent="showDialogNewPerson = true">[+ Nuevo]</a>
                                            <a href="#"
                                               v-if="form.customer_id"
                                               @click.prevent="showDialogDocuments = true">[Ver documentos]</a>

                                            <a href="#"
                                               v-if="configuration.enabled_label_by_sale_note && form.customer_id"
                                               @click.prevent="registerLabel">[Agregar rótulo]</a>
                                        </label>
                                        <el-select v-model="form.customer_id" filterable remote
                                                   class="border-left rounded-left border-info"
                                                   popper-class="el-select-customers"
                                                   dusk="customer_id"
                                                   placeholder="Escriba el nombre o número de documento del cliente"
                                                   :remote-method="searchRemoteCustomers"
                                                   @change="changeCustomer"
                                                   @focus="focus_on_client = true"
                                                   @blur="focus_on_client = false"
                                                   :loading="loading_search"
                                                   @keyup.enter.native="keyupCustomer">

                                            <el-option v-for="option in customers" :key="option.id" :value="option.id"
                                                       :label="option.description"></el-option>

                                        </el-select>
                                        <small class="form-control-feedback" v-if="errors.customer_id"
                                               v-text="errors.customer_id[0]"></small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4">
                                    <x-select label="Vendedor"
                                              v-model="form.seller_id"
                                              :options="sellers"
                                              option-label="name"></x-select>
                                </div>
                                <div class="col-lg-4">
                                    <x-input v-model="form.plate_number"
                                             label="Placa"></x-input>
                                </div>
                                <div class="col-lg-4">
                                    <x-input v-model="form.purchase_order"
                                             label="Orden de compra"></x-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-4">
                                    <x-input v-model="form.number_full"
                                             readonly
                                             label="Número"
                                             v-if="form.id"></x-input>
                                    <x-select v-model="form.series"
                                              label="Serie"
                                              :options="series"
                                              option-label="number"
                                              option-value="number"
                                              v-else
                                              :disabled="!!form.id"></x-select>
                                </div>
                                <div class="col-lg-4">
                                    <x-select label="Moneda"
                                              v-model="form.currency_type_id"
                                              :options="currency_types"
                                              option-label="symbol"
                                              @input="changeCurrencyType"></x-select>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4">
                                    <div class="form-group" :class="{'has-danger': errors.date_of_issue}">
                                        <label class="control-label">Fec. Emisión</label>
                                        <el-date-picker v-model="form.date_of_issue"
                                                        type="date"
                                                        format="dd/MM/yyyy"
                                                        value-format="yyyy-MM-dd"
                                                        :clearable="false"
                                                        @change="changeDateOfIssue"></el-date-picker>
                                        <small class="form-control-feedback" v-if="errors.date_of_issue"
                                               v-text="errors.date_of_issue[0]"></small>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <x-date-picker v-model="form.date_of_due"
                                                   label="Fec. Vencimiento"
                                                   :readonly="true"></x-date-picker>
                                </div>
                                <div class="col-lg-4">
                                    <x-input label="Tipo de cambio"
                                             v-model="form.exchange_rate_sale"
                                             :readonly="!config.enable_exchange_rate_sale"></x-input>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <x-input v-model="form.observations"
                                             label="Observaciones"
                                             type="textarea"></x-input>
                                </div>
                            </div>
                            <div class="col-12">
                                <x-switch-left v-model="form.use_unit_price"
                                               label="¿Usar precio unitario?"
                                               :disable="!showItemButtonAction"
                                               @input="changeUseUnitPrice"></x-switch-left>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th width="5%">#</th>
                                        <th class="font-weight-bold"
                                            width="30%">Descripción
                                        </th>
                                        <th width="8%" class="text-center font-weight-bold">Unidad</th>
                                        <th width="8%" class="text-center font-weight-bold">Cantidad</th>
                                        <th class="text-center font-weight-bold">Valor Unitario</th>
                                        <th class="text-center font-weight-bold">Precio Unitario</th>
                                        <th class="text-center font-weight-bold">Subtotal</th>
                                        <!--<th class="text-right font-weight-bold">Cargo</th>-->
                                        <th class="text-center font-weight-bold">Total</th>
                                        <th width="8%" v-if="showItemButtonAction"></th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="form.items.length > 0">
                                    <tr v-for="(row, index) in form.items" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ setDescriptionOfItem(row) }}
                                            <template v-if="row.item.presentation">
                                                {{ row.item.presentation.hasOwnProperty('description') ? row.item.presentation.description : '' }}
                                            </template>
                                            <br/><small>{{ row.affectation_igv_type_name }}</small>
                                            <template v-if="row.warehouse_id">
                                                <div v-if="row.item.warehouses"><b>{{ warehouseSeleted(row.item.warehouses, row.warehouse_id, row) }}</b>
                                                </div>
                                            </template>
                                            <template v-if="row.lots && row.lots.length > 0">
                                                <br/>Series: {{ showItemSeries(row.lots) }}
                                            </template>
                                        </td>
                                        <td class="text-center">{{ row.unit_type_id }}</td>
                                        <td class="text-center">{{ row.quantity }}</td>
                                        <!-- <td class="text-right">{{ currency_type.symbol }} {{ row.unit_price }}</td> -->
                                        <td class="text-center">{{ currency_type.symbol }}
                                            {{ getFormatUnitPriceRow(row.unit_value) }}
                                        </td>
                                        <td class="text-center">{{ currency_type.symbol }}
                                            {{ getFormatUnitPriceRow(row.unit_price) }}
                                        </td>

                                        <td class="text-center">{{ currency_type.symbol }} {{
                                                row.total_value
                                            }}
                                        </td>
                                        <td class="text-center">{{ currency_type.symbol }} {{ row.total }}</td>
                                        <td class="text-center" v-if="showItemButtonAction">
                                            <button class="btn waves-effect waves-light btn-xs btn-info"
                                                    type="button"
                                                    @click="clickEdiItem(row, index)">
                                                <span style='font-size:10px;'>&#9998;</span>
                                            </button>
                                            <button type="button"
                                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                                    @click.prevent="clickRemoveItem(index)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="9"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-lg-4">
                            <x-button-primary text="+ Agregar Producto"
                                              v-if="showItemButtonAction"
                                              @click="showDialogAddItem = true"></x-button-primary>
                        </div>
                        <div class="col-12 col-lg-8">
                            <table class="table table-sm text-right" v-if="form && form.items.length > 0">
                                <tbody>
                                <tr v-if="enabled_discount_global">
                                    <td>DESCUENTOS (-)</td>
                                    <td>:</td>
                                    <td>
                                        <x-select v-model="discount_global_type"
                                                  :options="[{'id': '01', 'name': currency_type.symbol}, {'id': '02', 'name': '%'}]"
                                                  :disabled="!showItemButtonAction"
                                                  @input="changeDiscountGlobalType">
                                        </x-select>
                                    </td>
                                    <td>
                                        <el-input-number v-model="discount_global_amount"
                                                         :min="0"
                                                         class="input-custom"
                                                         controls-position="right"
                                                         :disabled="!showItemButtonAction"
                                                         @change="calculateTotal"></el-input-number>
                                    </td>
                                </tr>
                                <tr v-if="form.total_exportation > 0">
                                    <td>OP.EXPORTACIÓN</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exportation }}</td>
                                </tr>
                                <tr v-if="form.total_free > 0">
                                    <td>OP.GRATUITAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_free }}</td>
                                </tr>
                                <tr v-if="form.total_unaffected > 0">
                                    <td>OP.INAFECTAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_unaffected }}</td>
                                </tr>
                                <tr v-if="form.total_exonerated > 0">
                                    <td>OP.EXONERADAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exonerated }}</td>
                                </tr>
                                <tr v-if="form.total_taxed > 0">
                                    <td>OP.GRAVADA</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_taxed }}</td>
                                </tr>
                                <tr>
                                    <td>SUBTOTAL</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.subtotal }}</td>
                                </tr>
                                <tr>
                                    <td>IGV</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_igv }}</td>
                                </tr>
                                <tr v-if="form.total_isc > 0">
                                    <td>ISC</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_isc }}</td>
                                </tr>
                                <tr v-if="form.total_plastic_bag_taxes > 0">
                                    <td>ICBPER</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_plastic_bag_taxes }}</td>
                                </tr>
                                <tr>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">TOTAL A PAGAR</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 40px!important;">:</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 70px!important;">
                                        {{ currency_type.symbol }}
                                    </td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 120px!important;">{{ form.total_payment }}</td>
                                </tr>
                                <tr v-if="form.total > 0">
                                    <td>CONDICIÓN DE PAGO</td>
                                    <td class="text-left">:</td>
                                    <td colspan="2">
                                        <x-select v-model="form.payment_condition_id"
                                                  :options="payment_conditions"
                                                  @input="changePaymentCondition"></x-select>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="form-actions text-right mt-3">
                    <el-button @click.prevent="close">Cancelar</el-button>
                    <el-button class="submit"
                               type="primary"
                               native-type="submit"
                               :loading="loading_submit"
                               v-if="form.items.length > 0">Generar
                    </el-button>
                </div>
            </form>
        </div>

        <sale-notes-form-item :showDialog.sync="showDialogAddItem"
                              :typeUser="typeUser"
                              :configuration="config"
                              :currency-types="currency_types"
                              :currency-type-id-active="form.currency_type_id"
                              :exchange-rate-sale="form.exchange_rate_sale"
                              :recordItem="recordItem"
                              :percentage-igv="percentageIgv"
                              :customer-id="form.customer_id"
                              :show-option-change-currency="true"
                              table="sale_notes"
                              @close="closeItem"
                              @add="addRow"></sale-notes-form-item>

        <person-form :showDialog.sync="showDialogNewPerson"
                     type="customers"
                     :external="true"
                     :input_person="input_person"
                     :document_type_id=form.document_type_id
                     @success="successPerson"></person-form>

        <sale-notes-options :showDialog.sync="showDialogOptions"
                            :typeUser="typeUser"
                            :record-data="recordData"
                            :resource="resource"
                            :parent-table="parentTable"
                            :show-new="showNew"
                            :configuration="config"></sale-notes-options>

        <store-document-items :show-dialog.sync="showDialogDocuments"
                              :resource="resource"
                              table="sale_notes"
                              document-type-id="80"
                              :person-id="form.customer_id"
                              @success="successDocuments"></store-document-items>

        <store-label-form :show-dialog.sync="showDialogLabel"
                          :record="formLabel"
                          @success="successRegisterLabel"></store-label-form>

        <store-document-payments :show-dialog.sync="showDialogDocumentPayments"
                                 :data="form"
                                 :form-id="id"
                                 @success="successDocumentPayments"></store-document-payments>

        <store-document-fee :show-dialog.sync="showDialogDocumentFee"
                            :data="form"
                            :form-id="id"
                            @success="successDocumentFee"></store-document-fee>
    </div>
</template>

<script>
import SaleNotesFormItem from '../Documents/partials/item.vue'
import PersonForm from '../persons/form.vue'
import SaleNotesOptions from '../Store/Finish.vue'
import {functions, exchangeRate} from '../../../mixins/functions'
import {calculateRowItem, fCalculateDiscountGlobal, fCalculateTotal, showNamePdfOfDescription, showNamePdfOfDescription2} from '../../../helpers/functions_3'
import Logo from '../companies/logo.vue'
import {mapActions, mapState} from "vuex/dist/vuex.mjs"
import Keypress from "vue-keypress"
import HeaderForm from "../../../components/Form/HeaderForm"
import StoreDocumentItems from "../Store/DocumentItems.vue"
import XButtonPrimary from "../../../components/Form/XButtonPrimary.vue"
import StoreLabelForm from "../Store/LabelForm.vue"
import XSelect from "../../../components/Form/XSelect.vue"
import moment from "moment/moment"
import StoreDocumentPayments from "../Documents/partials/DocumentPayment.vue"
import StoreDocumentFee from "../Documents/partials/DocumentFee.vue"
import XDatePicker from "../../../components/Form/XDatePicker.vue"
import XInput from "../../../components/Form/XInput.vue"
import StoreFinish from "../Store/Finish.vue";
import QuotationFormItem from "../Documents/partials/item.vue";
import XSwitchLeft from "../../../components/Form/XSwitchLeft.vue";

export default {
    props: [
        'id',
        'typeUser',
        'configuration',
        'authUser',
        'parentTable',
        'parentId',
        'action'
    ],
    components: {
        XSwitchLeft,
        QuotationFormItem,
        StoreFinish,
        XInput,
        XDatePicker,
        StoreDocumentFee,
        StoreDocumentPayments,
        XSelect,
        StoreLabelForm,
        XButtonPrimary,
        StoreDocumentItems,
        HeaderForm,
        SaleNotesFormItem,
        PersonForm,
        SaleNotesOptions,
        Logo,
        Keypress
    },
    mixins: [functions, exchangeRate],
    computed: {
        ...mapState([
            'config',
        ]),
        sms_periodo: function () {
            let text = '';
            let type = this.form.type_period;
            let time = this.form.quantity_period;
            if (time > 0 && (type === 'year' || type === 'month')) {
                text = "Se duplicará cada " + time;
                if (type === 'year') {
                    text = time > 1 ? text + ' años' : text + ' año';
                } else if (type === 'month') {
                    text = time > 1 ? text + ' meses' : text + ' mes';
                } else {
                    text = '';
                }
                return text;
            }
            return text;
        },
        showItemButtonAction() {
            return (this.action === 'new' && this.parentTable === null) || this.action === 'edit' || this.action === 'duplicate'
        },
        showLoadVoucher() {
            return this.configuration.show_load_voucher && !this.isUpdateDocument
        },
        isUpdateDocument() {
            return !_.isEmpty(this.id)
        },
        isGlobalDiscountBase() {
            return (this.config.global_discount_type_id === '02')
        },

    },
    data() {
        return {
            title: '',
            input_person: {},
            pickerOptions: {
                disabledDate: date => {
                    let now = new Date();
                    return date.getTime() < (now.getTime());
                },
            },
            multiple: [
                {
                    keyCode: 78, // N
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
                {
                    keyCode: 71, // g
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
            ],
            focus_on_client: false,
            sellers: [],
            resource: 'sale-notes',
            showDialogAddItem: false,
            showDialogNewPerson: false,
            showDialogOptions: false,
            showDialogDocuments: false,
            showDialogLabel: false,
            showDialogDocumentPayments: false,
            showDialogDocumentFee: false,
            loading_submit: false,
            loading_form: false,
            errors: {},
            form: {},
            currency_types: [],
            discount_types: [],
            charges_types: [],
            all_customers: [],
            customers: [],
            company: null,
            establishment: null,
            currency_type: {},
            saleNotesNewId: null,
            form_payment: {},
            payment_method_types: [],
            activePanel: 0,
            loading_search: false,
            type_periods: [],
            all_series: [],
            series: [],
            user_series: [],
            is_contingency: false,
            enabled_payments: true,
            payment_destinations: [],
            payment_conditions: [],
            total_discount_no_base: 0,
            total_global_charge: 0,
            global_charge_types: [],
            establishment: [],
            recordItem: null,
            headers_token: headers_token,
            global_discount_types: [],
            global_discount_type: {},
            is_amount: true,
            total_global_discount: 0,
            formLabel: {},
            enabled_discount_global: false,
            discount_type: null,
            discount_amount: null,
            discount_global_type: '01',
            discount_global_amount: 0,
            showHeaderForm: false,
            loadForm: false,
            recordData: null,
            establishmentId: null,
            sellerId: null,
            showNew: false,
        }
    },
    async created() {
        this.loadForm = false
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm()
        await this.$http.get(`/store/get_tables`)
            .then(response => {
                let data = response.data
                this.currency_types = data.currency_types
                this.all_customers = data.customer_defaults
                this.discount_types = data.discount_types
                this.charges_types = data.charges_types
                this.enabled_discount_global = data.enabled_discount_global
                this.global_charge_types = data.global_charge_types
                this.payment_method_types = data.payment_method_types
                this.company = data.company
                if (this.config.currency_type_id === undefined) {
                    this.form.currency_type_id = (this.currency_types.length > 0) ? this.currency_types[0].id : null
                }
                this.type_periods = [{id: 'month', description: 'Mensual'}, {id: 'year', description: 'Anual'}]
                this.all_series = data.series
                this.user_series = data.user_series
                this.payment_destinations = data.payment_destinations
                this.payment_conditions = data.payment_conditions
                this.global_discount_types = data.global_discount_types
                this.sellers = data.sellers
                this.sellerId = data.seller_id
                this.establishment = data.establishment
                this.establishmentId = data.establishment_id
            })

        this.initFormData()

        await this.getPercentageIgv();

        if (this.parentTable) {
            let url = `/store/record/${this.parentTable}/${this.parentId}/sale_notes`
            if (this.action) {
                url += `/${this.action}`
            }
            await this.$http.get(url)
                .then(response => {
                    let data = response.data
                    this.form = Object.assign({}, this.form, data.form)
                    let its = []
                    data.items.forEach((row) => {
                        its.push(calculateRowItem(row, this.percentageIgv, this.form.use_unit_price))
                    })
                    this.form.items = its
                    this.customers = data.persons
                    this.discount_global_type = data.general.discount_global_type
                    this.discount_global_amount = data.general.discount_global_amount
                    this.calculateTotal()
                })
            this.currency_type = this.currency_types.find(row => row.id === this.form.currency_type_id)
            if (this.action !== 'edit') {
                this.filterSeries()
            }
        } else {
            await this.changeDateOfIssue()
            this.filterSeries()
            this.changeCurrencyType()
            this.allCustomers()
        }

        if (!this.parentTable) {
            this.form.use_unit_price = this.configuration.include_igv;
        }

        if(this.action === 'new' || this.action === 'duplicate') {
            this.showNew = true
        }
        this.title = 'Nueva nota de venta'
        if (this.form.id) {
            this.title = 'Editar nota de venta'
        }
        await this.selectDefaultCustomer()
        this.loadForm = true
        this.loading_form = true
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                document_type_id: '80',
                series: null,
                number: '#',
                prefix: 'NV',
                establishment_id: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                date_of_due: moment().format('YYYY-MM-DD'),
                customer_id: null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                subtotal: 0,
                total_igv_free: 0,
                total: 0,
                total_payment: 0,
                operation_type_id: null,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                additional_information: null,
                actions: {
                    format_pdf: 'a4',
                },
                apply_concurrency: false,
                type_period: null,
                quantity_period: 0,
                automatic_date_of_issue: null,
                enabled_concurrency: false,
                plate_number: null,
                payment_method_type_id: null,
                payment_condition_id: '01',
                fee: [],
                paid: false,
                observations: null,
                terms_condition: null,
                seller_id: this.authUser.id,
                use_unit_price: false
            }

            this.total_discount_no_base = 0
            this.enabled_payments = true
            this.total_global_charge = 0
            this.total_global_discount = 0
            this.is_amount = true

        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
        },
        setDescriptionOfItem(row) {
            console.log('setDescriptionOfItem')
            return showNamePdfOfDescription2(row, this.config.show_pdf_name)
        },
        onSuccessUploadVoucher(response, file, fileList, index) {
            if (response.success) {
                this.form.payments[index].filename = response.data.filename
                this.form.payments[index].temp_path = response.data.temp_path
                this.form.payments[index].file_list = fileList
            } else {
                this.cleanFileListUploadVoucher(index)
                this.$message.error(response.message)
            }

        },
        cleanFileListUploadVoucher(index) {
            this.form.payments[index].file_list = []
        },
        handleRemoveUploadVoucher(file, fileList, index) {
            this.form.payments[index].filename = null
            this.form.payments[index].temp_path = null
            this.cleanFileListUploadVoucher(index)
        },
        disabledSeries() {
            return (this.configuration.restrict_series_selection_seller && this.typeUser !== 'admin')
        },
        clickAddItem() {
            this.recordItem = null
            this.showDialogAddItem = true
        },
        clickEdiItem(row, index) {
            row.indexi = index
            this.recordItem = row
            this.showDialogAddItem = true
        },
        getPaymentDestinationId() {
            if (this.config.destination_sale && this.payment_destinations.length > 0) {
                let cash = _.find(this.payment_destinations, {id: 'cash'})
                return (cash) ? cash.id : this.payment_destinations[0].id
            }
            return null
        },
        setTotalDefaultPayment() {

            if (this.form.payments.length > 0) {

                this.form.payments[0].payment = this.form.total
            }
        },
        filterSeries() {
            console.log('filterSeries')
            this.form.series = null
            this.series = this.all_series.filter(row => {
                return row.document_type_id === this.form.document_type_id
            })
            let user_series = null
            if (this.user_series.length > 0) {
                user_series = this.user_series.find(row => {
                    return row.document_type_id === this.form.document_type_id
                })
            }
            if (user_series) {
                let series = this.series.find(row => {
                    return row.id === user_series.series_id
                })
                if (series) {
                    this.form.series = series.number
                    return;
                }
            }

            this.form.series = (this.series.length > 0) ? this.series[0].number : null
        },
        getFormatUnitPriceRow(unit_price) {
            return _.round(unit_price, 6)
            // return unit_price.toFixed(6)
        },
        setDataUpdate() {
            if (this.form.total_charge > 0) this.total_global_charge = this.form.total_charge
            this.form.charges = (this.form.charges) ? Object.values(this.form.charges) : []
            this.form.discounts = this.getDataGlobalDiscount()
        },
        getDataGlobalDiscount() {
            const discounts = this.form.discounts ? Object.values(this.form.discounts) : []
            if (discounts.length === 1) {
                if (discounts[0].is_amount !== undefined && discounts[0].is_amount !== null) this.is_amount = discounts[0].is_amount
                this.total_global_discount = this.is_amount ? discounts[0].amount : (discounts[0].factor * 100)
            }
            return discounts
        },
        clickCancel(index) {
            this.form.payments.splice(index, 1);
        },
        changeCustomer() {
            let customer = _.find(this.customers, {'id': this.form.customer_id});
            // let seller = this.sellers.find(element => element.id == customer.seller_id)
            // if (seller !== undefined) {
            //     this.form.seller_id = seller.id
            // }
        },
        searchRemoteCustomers(input) {
            if (input.length > 0) {
                this.loading_search = true
                let parameters = `input=${input}`

                this.$http.get(`/${this.resource}/search/customers?${parameters}`)
                    .then(response => {
                        this.customers = response.data.customers
                        this.loading_search = false
                        /* if(this.customers.length == 0){this.allCustomers()} */
                        this.input_person.number = (this.customers.length == 0) ? input : null
                    })
            } else {
                this.allCustomers()
                this.input_person.number = null
            }

        },
        async resetForm() {
            this.activePanel = 0
            this.initForm()
            this.initFormData()
            this.filterSeries()
            await this.changeDateOfIssue()
            this.changeCurrencyType()
            this.allCustomers()
        },
        cleanCustomer() {
            this.form.customer_id = null
        },
        async changeDateOfIssue() {
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            })
            await this.getPercentageIgv();
            this.changeCurrencyType();
        },
        allCustomers() {
            this.customers = this.all_customers
        },
        addRow(row) {
            console.log('addRow')
            let _row = JSON.parse(JSON.stringify(row))
            _row = this.changeCurrencyTypeRow(_row)
            let rowNew = calculateRowItem(_row, this.percentageIgv, this.form.use_unit_price)
            if (this.recordItem) {
                this.form.items[this.recordItem.indexi] = rowNew
                this.recordItem = null
            } else {
                this.form.items.push(rowNew)
            }
            this.calculateTotal()
        },
        closeItem() {
            console.log('closeItem')
            this.showDialogAddItem = false
            this.recordItem = null
        },
        clickRemoveItem(index) {
            this.form.items.splice(index, 1)
            this.calculateTotal()
        },
        changeCurrencyType() {
            console.log('changeCurrencyType')
            this.currency_type = this.currency_types.find(row => {
                return row.id === this.form.currency_type_id
            })
            let items = []
            this.form.items.forEach((row) => {
                let _row = JSON.parse(JSON.stringify(row))
                _row = this.changeCurrencyTypeRow(_row)
                items.push(calculateRowItem(_row, this.percentageIgv, this.form.use_unit_price))
            });
            this.form.items = items
            this.calculateTotal()
        },
        changeCurrencyTypeRow(row) {
            if (row.currency_type_id_init === 'PEN' && this.form.currency_type_id === 'USD') {
                row.unit_price = Number(row.unit_price_init) / this.form.exchange_rate_sale
                row.unit_value = Number(row.unit_value_init) / this.form.exchange_rate_sale
            }
            if (row.currency_type_id_init === 'USD' && this.form.currency_type_id === 'PEN') {
                row.unit_price = Number(row.unit_price_init) * this.form.exchange_rate_sale
                row.unit_value = Number(row.unit_value_init) * this.form.exchange_rate_sale
            }
            if (row.currency_type_id_init === this.form.currency_type_id) {
                row.unit_price = Number(row.unit_price_init)
                row.unit_value = Number(row.unit_value_init)
            }
            row.currency_type_id = this.form.currency_type_id
            return row
        },
        changeUseUnitPrice() {
            let items = []
            this.form.items.forEach((row) => {
                let _row = JSON.parse(JSON.stringify(row))
                items.push(calculateRowItem(_row, this.percentageIgv, this.form.use_unit_price))
            });
            this.form.items = items
            this.calculateTotal()
        },
        calculateTotal() {
            console.log('calculateTotal')
            this.form = Object.assign({}, this.form, fCalculateTotal(this.form, this.percentageIgv, this.form.use_unit_price))
            this.calculateDiscountGlobal()
        },
        calculateDiscountGlobal() {
            console.log('calculateDiscountGlobal')
            this.form = Object.assign({}, this.form,
                fCalculateDiscountGlobal(this.form, this.enabled_discount_global, this.discount_global_type, this.discount_global_amount))
            this.getTotal();
        },
        changeDiscountGlobalType() {
            console.log('changeDiscountGlobalType')
            this.calculateDiscountGlobal()
        },
        getTotal() {
            console.log('getTotal')
            let total = Number(this.form.total)
            this.form.total_payment = total.toFixed(2)
        },
        getGlobalCharge(id) {
            return _.find(this.global_charge_types, {id: id})
        },
        chargeGlobal() {
            let base = parseFloat(this.form.total)
            if (this.config.active_allowance_charge) {
                let percentage_allowance_charge = parseFloat(this.config.percentage_allowance_charge)
                this.total_global_charge = (base * percentage_allowance_charge / 100).toFixed(2)
            }

            if (this.total_global_charge === 0) {
                this.deleteChargeGlobal()
                return
            }

            let amount = parseFloat(this.total_global_charge)
            let factor = _.round(amount / base, 5)
            let charge = _.find(this.form.charges, {charge_type_id: '50'})

            if (amount > 0 && !charge) {
                this.form.total_charge = _.round(amount, 2)
                this.form.total = _.round(this.form.total + this.form.total_charge, 2)
                const global_charge = this.getGlobalCharge('50')

                this.form.charges.push({
                    charge_type_id: global_charge.id,
                    description: global_charge.description,
                    factor: factor,
                    amount: amount,
                    base: base
                })

            } else {

                let pos = this.form.charges.indexOf(charge);

                if (pos > -1) {

                    this.form.total_charge = _.round(amount, 2)
                    this.form.total = _.round(this.form.total + this.form.total_charge, 2)

                    this.form.charges[pos].base = base
                    this.form.charges[pos].amount = amount
                    this.form.charges[pos].factor = factor

                }
            }

        },
        deleteChargeGlobal() {
            let charge = _.find(this.form.charges, {charge_type_id: '50'})
            let index = this.form.charges.indexOf(charge)

            if (index > -1) {
                this.form.charges.splice(index, 1)
                this.form.total_charge = 0
            }
        },
        async submit() {
            if (this.config.affect_all_documents) {
                this.form.terms_condition = this.config.terms_condition_sale;
            }
            if (this.form.type_period) {
                if (this.form.quantity_period === 0) {
                    return this.$message.error('La cantidad de periodos debe ser mayor a 0')
                }
                this.form.enabled_concurrency = (this.form.quantity_period > 0)
            }

            if (this.form.id === null) {
                if (this.form.payment_condition_id === '01') {
                    this.form.fee = []
                } else if (this.form.payment_condition_id === '02') {
                    this.form.payments = []
                } else {
                    this.form.fee = []
                    this.form.payments = []
                }
            }

            if (this.form.payment_condition_id === '01') {
                if (this.form.payments.length === 0) {
                    return this.$message.error('El registro de pagos es obligatorio');
                }
            }

            if (this.form.payment_condition_id === '02') {
                if (this.form.fee.length === 0) {
                    return this.$message.error('El registro de cuotas es obligatorio');
                }
                this.form.date_of_due = this.form.fee[this.form.fee.length - 1].date
            }

            if (!['01', '02'].includes(this.form.payment_condition_id)) {
                this.form.fee = [];
                this.form.fee.push({
                    id: null,
                    document_id: null,
                    payment_method_type_id: null,
                    date: this.form.date_of_due,
                    currency_type_id: this.form.currency_type_id,
                    amount: this.form.total_payment,
                });
            }
            this.loading_submit = true
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.resetForm()
                        this.recordData = response.data.data
                        this.showDialogOptions = true
                    } else {
                        this.$message.error(response.data.message);
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data;
                    } else {
                        this.$message.error(error.response.data.message);
                    }
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading_submit = false
                })
        },
        validate_payments() {
            for (let index = 0; index < this.form.payments.length; index++) {
                if (parseFloat(this.form.payments[index].payment) === 0)
                    this.form.payments.splice(index, 1)
            }
            let error_by_item = 0
            let acum_total = 0
            this.form.payments.forEach((item) => {
                acum_total += parseFloat(item.payment)
                if (item.payment <= 0 || item.payment == null) error_by_item++;
            })

            return {
                error_by_item: error_by_item,
                acum_total: acum_total
            }
        },
        async selectDefaultCustomer() {
            if (this.establishment.customer_id) {
                const customer = this.all_customers.find(row => row.id === this.establishment.customer_id)
                if (!customer) {
                    await this.$http.get(`/${this.resource}/search/customer/${this.establishment.customer_id}`)
                        .then((response) => {
                            let data_customer = response.data.customers
                            this.all_customers.push(...data_customer)
                            this.customers.push(...data_customer)
                        })
                }
                let alt = this.customers.find(row => row.id === this.establishment.customer_id)
                if (alt !== undefined) {
                    this.form.customer_id = this.establishment.customer_id
                    let seller = this.sellers.find(element => element.id === alt.seller_id)
                    if (seller !== undefined) {
                        this.form.seller_id = seller.id
                    }
                }
            }
        },
        // async selectDefaultCustomer() {
        //     if (this.config.establishment.customer_id) {
        //         let temp_all_customers = this.all_customers;
        //         let temp_customers = this.customers;
        //         await this.$http.get(`/${this.resource}/search/customer/${this.config.establishment.customer_id}`)
        //             .then((response) => {
        //                 let data_customer = response.data.customers
        //                 temp_all_customers = temp_all_customers.push(...data_customer)
        //                 temp_customers = temp_customers.push(...data_customer)
        //             })
        //         temp_all_customers = this.all_customers.filter((item, index, self) =>
        //                 index === self.findIndex((t) => (
        //                     t.id === item.id
        //                 ))
        //         )
        //         temp_customers = this.customers.filter((item, index, self) =>
        //                 index === self.findIndex((t) => (
        //                     t.id === item.id
        //                 ))
        //         )
        //         this.all_customers = temp_all_customers;
        //         this.customers = temp_customers;
        //         let alt = _.find(this.customers, {'id': this.config.establishment.customer_id});

        //         if (alt !== undefined) {
        //             this.form.customer_id = this.config.establishment.customer_id
        //         }
        //     }
        // },
        checkKeyWithAlt(e) {
            let code = e.event.code;
            if (
                this.showDialogOptions === true &&
                code === 'KeyN'
            ) {
                this.showDialogOptions = false
            }

            if (
                code === 'KeyG'  // key G
                && !this.showDialogAddItem   // Modal hidden
                && this.form.items.length > 0  // with items
                && this.focus_on_client === false // not client search
            ) {
                this.submit()
            }
        },
        checkKey(e) {
            let code = e.event.code;
            if (code === 'F2') {
                //abrir el modal de agergar producto
                if (!this.showDialogAddItem) this.showDialogAddItem = true
            }
            if (code === 'Escape') {
                if (this.showDialogAddItem) {
                    this.showDialogAddItem = false;
                }
            }
        },
        keyupCustomer() {

            if (this.input_person.number) {

                if (!isNaN(parseInt(this.input_person.number))) {

                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break;

                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                    }
                }
            }
        },
        successDocuments(items) {
            items.forEach(it => {
                this.form.items.push(it);
            })
        },
        warehouseSeleted(warehouses, warehouse_id) {
            if (warehouses !== undefined) {
                var warehouseSeleted = warehouses.filter(row => {
                    return row.warehouse_id === warehouse_id
                })
                return warehouseSeleted[0].warehouse_description
            }
        },
        registerLabel() {
            let person = _.find(this.customers, {'id': this.form.customer_id})
            let person_address = _.find(this.customer_addresses, {'id': this.form.customer_address_id})
            if (this.form.label) {
                this.formLabel = Object.assign({}, this.formLabel, this.form.label)
            } else {
                if (person_address) {
                    this.formLabel = Object.assign({}, this.formLabel, {
                        'address': person_address.address,
                        'location_id': person_address.location_id,
                        'address_reference': person.address_reference,
                        'cellphone_number': person.cellphone_number,
                    });
                } else {
                    this.formLabel = Object.assign({}, this.formLabel, {
                        'address': person.address,
                        'location_id': person.location_id,
                        'address_reference': person.address_reference,
                        'cellphone_number': person.cellphone_number,
                    })
                }
            }
            this.showDialogLabel = true
        },
        successRegisterLabel(data) {
            this.form.label = Object.assign({}, this.form.label, data)
            this.showDialogLabel = false
        },
        changePaymentCondition() {
            console.log('changePaymentCondition')
            if (!['01', '02'].includes(this.form.payment_condition_id)) {
                let pc = _.find(this.payment_conditions, {'id': this.form.payment_condition_id});
                this.form.date_of_due = moment(this.form.date_of_issue).add(pc.days, 'days').format('YYYY-MM-DD');
            } else {
                this.form.date_of_due = moment(this.form.date_of_issue).format('YYYY-MM-DD');
            }
        },
        preSubmit() {
            console.log('preSubmit')
            if (this.form.payment_condition_id === '01') {
                this.showDialogDocumentPayments = true
                return
            }
            if (this.form.payment_condition_id === '02') {
                this.showDialogDocumentFee = true
                return
            }
            this.submit()
        },
        async successDocumentPayments(data) {
            console.log('successDocumentPayments')
            this.showDialogDocumentPayments = false
            this.form.payments = data
            await this.submit()
        },
        async successDocumentFee(data) {
            console.log('successDocumentFee')
            this.showDialogDocumentFee = false
            this.form.fee = data
            await this.submit()
        },
        showItemSeries(series) {
            console.log('showItemSeries')
            return series.map(o => o['series']).join(', ');
        },
        successPerson(data) {
            this.form.customer_id = data.id
            this.customers = data.data
            this.changeCustomer()
        },
        close() {
            location.href = `/${this.resource}`
        },
    }
}
</script>
